import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './ui.css';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * - `primario`: relleno de marca («Guardar»).
   * - `secundario`: borde de marca sobre blanco («Guardar y agregar otro»).
   * - `texto`: texto gris sobre fondo gris claro («Cancelar»).
   * - `peligro`: borde y texto rojos («Desactivar»).
   */
  variante?: 'primario' | 'secundario' | 'texto' | 'peligro';
  /** Ícono antes del texto. */
  icono?: ReactNode;
  /** Botón cuadrado de 40×40 sin texto visible —el «•••»—. Exige `aria-label`. */
  soloIcono?: boolean;
}

/**
 * El botón del Figma (componente «Boton»): 40 px de alto, radio 5, Mona Sans
 * Medium 14.
 *
 * `type="button"` por omisión: el `submit` implícito de HTML hace que un botón
 * cualquiera dentro de un formulario lo envíe, y eso se descubre tarde.
 */
export function Boton({
  variante = 'primario',
  icono,
  soloIcono = false,
  className,
  children,
  type = 'button',
  ...resto
}: Props) {
  const clases = ['ui-boton', `ui-boton--${variante}`, soloIcono && 'ui-boton--icono', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={clases} {...resto}>
      {icono}
      {children}
    </button>
  );
}
